import { PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@/contexts/authContext';
import { PUBLIC_ROUTES } from '@/routes/routes';

const PrivateRoute = ({ children }: PropsWithChildren) => {
  const { auth } = useContext(AuthContext);
  const { idToken } = auth;

  if (!idToken) {
    return <Navigate to={PUBLIC_ROUTES.SIGN_IN} />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
